let playButton = document.querySelector('.h1000 #play-button')
let video = document.querySelector('video')
if (playButton && video) {
    
    playButton.onclick = ()=> {
        video.play();
        playButton.classList.add('hidden');
        video.setAttribute("Controls", "");
    }

    video.onplay = (event)=> {
        playButton.classList.add('hidden')
        playButton.parentElement.classList.remove('after:inset-0')
    }

    video.onpause = ()=> {
        playButton.classList.remove('hidden')
    }
}